module.exports = __webpack_public_path__ + "img/btn3.28c06d31.png";